/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * RightArrowIcon - Auto-generated from icon.js
 */
export const RightArrowIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg
		width="16"
		height="14"
		viewBox="0 0 16 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M5.09477e-07 8.17226L12.6738 8.17226L8.07473 12.7714L9.30336 14L16 7.30336L9.30336 0.606711L8.07473 1.83534L12.6738 6.43445L6.61401e-07 6.43445L5.09477e-07 8.17226Z" fill="#676767" />
	</svg>
);

export default RightArrowIcon;
